import {Button} from "@/components/ui/button.tsx";
import {Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle} from
    "@/components/ui/dialog.tsx";
import type {DungeonLevel} from "@/dungeons/model/DungeonLevel.ts";
import type {LevelTransition} from "@/dungeons/model/DungeonGeometry.ts";

export default function LevelTransitionDialog({transition, targetLevel, tokenCount, ready, busy, onClose,
    onConfirm}: {
    transition: LevelTransition;
    targetLevel?: DungeonLevel;
    tokenCount: number;
    ready: boolean;
    busy: boolean;
    onClose: () => void;
    onConfirm: () => void;
}) {
    return <Dialog open onOpenChange={open => {if (!open) onClose();}}>
        <DialogContent showCloseButton={!busy}>
            <DialogHeader>
                <DialogTitle>{transition.label?.trim() || "Levelübergang"}</DialogTitle>
                <DialogDescription>
                    {ready && targetLevel
                        ? `${tokenCount} ${tokenCount === 1 ? "Token" : "Tokens"} nach „${targetLevel.name}“ versetzen? ` +
                            "Die Formation bleibt erhalten und die Ansicht wechselt zum Ankunftspunkt."
                        : !targetLevel
                            ? "Für diesen Übergang ist noch kein Ziellevel festgelegt."
                            : "Wähle zuerst mindestens ein Token auf diesem Level aus."}
                </DialogDescription>
            </DialogHeader>
            <DialogFooter>
                <Button type="button" variant="outline" disabled={busy} onClick={onClose}>Abbrechen</Button>
                <Button type="button" disabled={!ready || busy} onClick={onConfirm}>
                    {busy ? "Wechsle Level…" : "Level wechseln"}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>;
}
